// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"175":"276deb6b","238":"bf4273c6","644":"7a74b260","732":"d8a68ec5","865":"4e3daca0"}[chunkId] + ".chunk.js";
};